import type {
  SelectableData,
  SelectModeBoundingRect,
  SelectModeClickPosition,
  SelectModeInlineTextStatus,
  SelectModeSelectionRect,
  SelectModeTiptapActiveMarks,
} from "schemas/generated/selectMode";

import React from "react";

import { useBedrock } from "../BedrockProvider";
import { parentRemote } from "../miniappRpc";

export function useSelectModeInteractions() {
  const { agentUiState } = useBedrock();
  const displayMode = agentUiState?.displayMode ?? "browse";

  return React.useMemo(
    () => ({
      displayMode,
      reportHover: (rect: SelectModeBoundingRect | null) => {
        parentRemote.selectModeHoverChanged({ rect });
      },
      reportSelection: (data: SelectableData | null) => {
        parentRemote.selectModeSelectionChanged({ data });
      },
      reportAreaSelection: ({
        rect,
        items,
      }: {
        rect: SelectModeBoundingRect;
        items: SelectableData[];
      }) => {
        parentRemote.selectModeAreaSelectionChanged({ rect, items });
      },
      reportDragRect: ({
        dragRect,
        selectionRects,
      }: {
        dragRect: SelectModeBoundingRect | null;
        selectionRects: SelectModeSelectionRect[];
      }) => {
        parentRemote.selectModeDragRectChanged({ dragRect, selectionRects });
      },
      reportRectUpdate: (
        update:
          | {
              type: "element";
              rect: SelectModeBoundingRect;
              clickPosition: SelectModeClickPosition;
            }
          | { type: "area"; rect: SelectModeBoundingRect },
      ) => {
        parentRemote.selectModeRectUpdated(update);
      },
      reportClearSelection: () => {
        parentRemote.selectModeClearSelection();
      },
      reportInlineEditState: (state: {
        isEditing: boolean;
        isPending?: boolean;
        activeMarks: SelectModeTiptapActiveMarks;
      }) => {
        parentRemote.selectModeInlineEditStateChanged(state);
      },
      reportInlineTextStatus: ({
        status,
        translationKey,
      }: {
        status: SelectModeInlineTextStatus;
        translationKey: string | null;
      }) => {
        parentRemote.selectModeInlineTextStatusChanged({
          status,
          translationKey,
        });
      },
    }),
    [displayMode],
  );
}
